<template>
  <div>
    <v-combobox
      v-model="select"
      :items="items"
      :search-input.sync="search"
      :error-messages="hint"
      :label="label"
      :disabled="disabled"
      multiple
      chips
      deletable-chips
      @change="selectChanged"
    >
      <template v-slot:selection="{ item, parent, selected }">
        <v-chip :selected="selected" label>
          <span class="pr-2">{{ item }}</span>
          <v-icon small @click="parent.selectItem(item)">close</v-icon>
        </v-chip>
      </template>
      <template v-slot:item="{ item, tile: { props } }">
        <v-list-tile-action>
          <v-checkbox :value="props.value" :input-value="props.value" readonly></v-checkbox>
        </v-list-tile-action>
        <v-list-tile-content>
          {{ item }}
        </v-list-tile-content>
        <v-spacer></v-spacer>
        <v-list-tile-action @click.stop>
          <v-btn icon @click.stop.prevent="deleteItem(item)">
            <v-icon>delete</v-icon>
          </v-btn>
        </v-list-tile-action>
      </template>
    </v-combobox>
  </div>
</template>

<script>
import { read, save } from '@/storage';
import { STORE_KEY_EMAIL_CATALOG } from '@/constants';
export default {
  props: {
    value: {
      type: String,
      default: ''
    },
    label: {
      type: String,
      default: ''
    },
    disabled: {
      type: Boolean,
      default: false
    },
    storageCatalogKey: {// catalog, storage-catalog, storage-catalog-key
      type: String,
      default: STORE_KEY_EMAIL_CATALOG
    },
    rules: {
      type: Array,
      default: () => [v => !!v || 'Item is required']
    }
  },
  data() {
    return {
      select: [],
      items: [],
      search: null
    }
  },
  methods: {
    selectParse(text) {
      const selectParsed = !!text ? text.split(',') : [];
      this.select = selectParsed;
      this.setCatalog(selectParsed);
    },
    setCatalog(items, isOverride = false) {
      let storedItems = JSON.parse(!isOverride && read(this.storageCatalogKey) || '[]');
      const mergedSet = new Set(storedItems.concat(items));
      storedItems = Array.from(mergedSet);
      save(this.storageCatalogKey, JSON.stringify(storedItems));

      this.items = storedItems;
    },
    selectStringify(val) {
      const selectStringified = val.join(',');
      this.$emit('input', selectStringified);
    },
    searchErrors(val) {
      // console.log('search validate');
      const errors = [];
      this.rules.forEach(rule => {
        if (rule(val) !== true) {
          errors.push(rule(val));
        }
      })
      return errors.join(', ');
    },
    deleteItem(item) {
      const index = this.items.indexOf(item);
      this.items.splice(index, 1);
      this.setCatalog(this.items, true);
      if (this.select.includes(item)) {
        const selectIndex = this.select.indexOf(item);
        this.select.splice(selectIndex, 1);
      }
    },
    selectChanged(evt) {
      const lastSelect = evt[evt.length-1];
      if (!!this.searchErrors(lastSelect)) {
        this.select.pop();
      }
    }
  },
  computed: {
    hint() {
      return this.searchErrors(this.search);
    }
  },
  watch: {
    value(val) {
      // console.log('watch value', val);
      this.selectParse(val);
    },
    select: {
      handler(val) {
        // console.log('watch select', val);
        this.setCatalog(val);
        this.selectStringify(val);
      },
      deep: true
    }
  },
  mounted() {
    // console.log('mounted', this.value);
    this.selectParse(this.value);
  }
}
</script>